<div class="animated-glow" aria-hidden="true"></div>
<div tabindex="-1" class="goo" aria-hidden="true">
  <div aria-hidden="true" class="blob a a1"></div>
  <div aria-hidden="true" class="blob a a2"></div>
  <div aria-hidden="true" class="blob a a3"></div>
  <div aria-hidden="true" class="blob a a4"></div>
  <div aria-hidden="true" class="blob b b1"></div>
  <div aria-hidden="true" class="blob b b2"></div>
  <div aria-hidden="true" class="blob b b3"></div>
  <div aria-hidden="true" class="blob b b4"></div>
</div>

<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" version="1.1" style="position: absolute">
  <defs>
    <filter id="goo">
      <fegaussianblur in="SourceGraphic" stdDeviation="12" result="blur" />
      <fecolormatrix
        in="blur"
        mode="matrix"
        values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -6"
        result="goo" />
      <feblend in="SourceGraphic" in2="blob" />
    </filter>
  </defs>
</svg>
